import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from '../../hook-utils';
import { TaskItemAction } from '../../model';
import { actions } from '../../store';
import { getTweetById, selectTweetByReply } from '../../store/reducers/twitter';
import Modal from '../Modal';
import { CallViewByItemDetails } from './CallDetailsPanel';
import TweatView from './TweatView';


export interface ShowTweetState {
  tweetId: string
  reply: boolean
}

export default function TweatViewPanelByTweetId({ tweetId, reply, onClose }: { tweetId: string, reply: boolean, onClose(): void }) {
  const tweet = useSelector(s => !reply ? getTweetById(s, tweetId) : selectTweetByReply(s, tweetId))
  const dispatch = useDispatch()

  useEffect(() => {
    if (tweetId === '' || tweet) return 
    
    dispatch(actions.fetchTweetRequest(tweetId, '', reply))
  }, [dispatch, tweetId, reply, tweet])

  function handleClose() {
    //should do this but need to check if it's active in agent view before doing it
    //dispatch(actions.removeMediaItem(tweetId))

    onClose()
  }

  if (!tweet) { return null }

  const customStyles = {
    content: {
      width: '50%',
      height: '70%',
    },
  };

  return <Modal style={customStyles} isOpen={true} className='EmailModal'>
    <CallViewByItemDetails itemId={tweetId} itemType='TWEET' itemAction={TaskItemAction.none} onClose={() => {
      handleClose()
    }} />
    <TweetViewPanel tweetId={tweetId} reply={reply} onClose={() => {
      handleClose()
    }} />
  </Modal>
}

export function TweetViewPanel({ tweetId, reply, onClose }: { tweetId: string, reply: boolean, onClose?(tweetId: string): void }) {
  const tweet = useSelector(s => !reply ? getTweetById(s, tweetId) : selectTweetByReply(s, tweetId))
  const dispatch = useDispatch()

  useEffect(() => {
    if (tweetId === '' || tweet) return 

    dispatch(actions.fetchTweetRequest(tweetId, '', reply))
  }, [dispatch, tweetId, reply, tweet])

  if (!tweet) { return null }

  return <div>
    <TweatView tweetId={tweetId} queueId={tweet.queueId} reply={reply} />
  </div>
}
